import React, { useState, useEffect } from 'react';
import { Button, Input, message, Upload } from 'antd';
import BaseColumnInput from '../../../components/input/base_column_input';
import BaseColumnSelect from '../../../components/select/base_column_select';
import BaseColumnPassword from '../../../components/input/base_column_password';
import { restApi, getFileHost, getFileUploadToken } from '../../../apis';

const TrainerPofileDetailCreate = (props) => {
  const {
    trainerId,
    setTrainerName,
    setLoading,
    loading,
    isRead,
    data,
    setData,
    centers = [
      {
        value: null,
        label: `센터정보 없음`,
      },
    ],
    ...rest
  } = props;

  const [messageApi, contextHolder] = message.useMessage();

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      messageApi.error('You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      messageApi.error('Image must smaller than 2MB!');
    }
    return isJpgOrPng && isLt2M;
  };

  const handleChange = (info) => {
    const { status } = info.file;

    /*
    // log
    if (status !== 'uploading') {
      console.log(info.file, info.fileList);
    }
    */
    if (status == 'uploading') {
      if (loading == false) {
        setLoading(true);
      }
    }
    if (status === 'done') {
      message.success(`${info.file.name} file uploaded successfully.`);
      // console.log('-[file]--->', info.file);
      const payload = info?.file?.response?.payload;
      if (payload) {
        setData((prev) => {
          return {
            ...prev,
            photoKey: payload?.files[0].id,
            photoPath: payload?.files[0].path,
            photoExt: payload?.files[0].ext,
          };
        });
      }

      setLoading(false);
    } else if (status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
      setLoading(false);
    }
  };

  return (
    <div style={{ ...styles.container }}>
      {contextHolder}
      <div
        style={{
          ...styles.row,
          padding: '4rem 1rem 4rem 1rem',
          borderBottom: '1px solid #DBDADE',
          alignItems: 'stretch',
        }}
      >
        <div
          style={{
            ...styles.column,
            flex: undefined,
            width: 136,
            height: 136,
            marginLeft: '1rem', // '2.4rem','1.4rem',
            marginRight: '0.9rem',
            alignItems: 'center',
            justifyContent: 'center',
            // border: '1px solid #DBDADE',
            backgroundRepeat: 'no-repeat',
            backgroundImage: `url(${require('../../../assets/images/bkg_profile.png')})`,
          }}
        >
          <Upload
            name="avatar"
            showUploadList={false}
            beforeUpload={beforeUpload}
            onChange={handleChange}
            //---------------------------------------------
            action={getFileHost()}
            headers={{
              Authorization: `Bearer ${getFileUploadToken()}`,
            }}
            method="post"
            //Content-Disposition: form-data; name="Filedata"; filename="undefined"
            // name="filedata" /// <=== 파일 데이터 저장할 이름
            //---------------------------------------------
          >
            {data?.photoPath ? (
              <img
                width={136}
                height={136}
                // src={`url(${require('../../../assets/images/sample_profile.png')})`}
                // src={require('../../../assets/images/sample_profile.png')}
                // src={require('../../../assets/images/sample_profile.png')}
                src={`https://cdn.humanb.kr/${data?.photoPath}/${data?.photoKey}.${data?.photoExt}`}
                alt={`no image`}
              />
            ) : (
              <div style={{ marginTop: 8 }}>{`프로필 등록`}</div>
            )}
          </Upload>
        </div>

        <div style={{ ...styles.column }}>
          <BaseColumnInput
            label={`성명`}
            readonly={isRead}
            onChange={(e) => {
              setData((prev) => {
                return {
                  ...prev,
                  name: String(e.target.value).trim(),
                };
              });
            }}
            width={'32rem'}
            placeholder={data.name}
            // value={''}
          />
          <BaseColumnInput
            label={`개인 전화번호`}
            readonly={isRead}
            onChange={(e) => {
              setData((prev) => {
                return {
                  ...prev,
                  phone: String(e.target.value).trim(),
                };
              });
            }}
            width={'32rem'}
            placeholder={data.phone}
            // value={'01012345678'}
          />
        </div>
        <div style={{ ...styles.column }}>
          <BaseColumnInput
            label={`이메일`}
            readonly={isRead}
            onChange={(e) => {
              setData((prev) => {
                return {
                  ...prev,
                  email: String(e.target.value).trim(),
                };
              });
            }}
            width={'32rem'}
            // value={'abce@test.com'}
            placeholder={data.email}
          />
          {/*
           <BaseColumnInput
            label={`센터 전화번호`}
            readonly={isRead}
            onChange={(e) => {
              setData((prev) => {
                return {
                  ...prev,
                  center_phone: String(e.target.value).trim(),
                };
              });
            }}
            width={'32rem'}
            // value={'01012345678'}
            placeholder={data.centerPhone}
          />
        */}
        </div>
        <div style={{ ...styles.column }}>
          {/* <BaseColumnSelect
            label={`소속센터`}
            readonly={isRead}
            options={centers}
            onChange={(selectedValue) => {
              // console.log(`Selected: ${selectedValue}`);
              setData &&
                setData((prev) => {
                  return {
                    ...prev,
                    centerId: selectedValue,
                  };
                });
            }}
            width={'32rem'}
            value={data?.centerId}
          /> */}
          <BaseColumnInput
            label={`센터 고유 코드`}
            readonly={isRead}
            width={'32rem'}
            onChange={(e) => {
              setData((prev) => {
                return {
                  ...prev,
                  center_code: String(e.target.value).trim(),
                };
              });
            }}
            // value={'busan_humanfit_05user'}
            placeholder={data.center_code}
          />
        </div>
        <div style={{ ...styles.column }}>
          <BaseColumnPassword
            label={`비밀번호`}
            readonly={isRead}
            onChange={(e) => {
              setData((prev) => {
                return {
                  ...prev,
                  isChangePasword: true,
                  password: e.target.value,
                };
              });
            }}
            placeholder={'********'}
            width={'32rem'}
          />
          <BaseColumnPassword
            label={`비밀번호 확인`}
            readonly={isRead}
            onChange={(e) => {
              setData((prev) => {
                return {
                  ...prev,
                  confirmPwd: e.target.value,
                };
              });
            }}
            placeholder={'********'}
            width={'32rem'}
          />
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: 0,
    // font
    fontFamily: 'Public Sans',
    fontStyle: 'normal',
    /*
    fontWeight: 600,
    fontSize: '1.3rem',
    lineHeight: '1.5rem',
    letterSpacing: 1,
    textTransform: 'uppercase',
		*/
  },
  title: {
    display: 'flex',
    width: '50rem',
    // flexDirection: 'row',
    alignItems: 'center',
    // justifyContent: 'center',

    fontWeight: 600,
    fontSize: '1.8rem',
    lineHeight: '2.4rem',
    // letterSpacing: 1,
    // textTransform: 'uppercase',
  },
  col_title: {
    display: 'flex',
    // flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    //font
    fontWeight: 400,
    fontSize: '1.3rem',
    lineHeight: '1.5rem',
  },
  botton_update: {
    display: 'flex',
    width: '14.3rem',
    height: '3.8rem',
    alignItems: 'center',
    justifyContent: 'center',

    border: 0,
    background: `linear-gradient(72.47deg, #7367F0 22.16%, rgba(115, 103, 240, 0.7) 76.47%)`,
    // ...item.style,
    color: '#FFF',
  },
  row: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0rem 2.4rem 0rem 2.4rem',
    background: '#FFFFFF',
  },
  column: {
    display: 'flex',
    // height: '100%',
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0rem 0.9rem 0rem 0.9rem',
    background: '#FFFFFF',
  },
};
export default TrainerPofileDetailCreate;
